import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {useAuth} from "context/AuthContext";

interface ClassData {
    id: number;
    location_name: string;
    class_name: string;
    instructor: string;
    start_time: string;
    end_time: string;
}

interface CurrentClassProps {
    locationName: string;
}

const CurrentClass: React.FC<CurrentClassProps> = ({ locationName }) => {
    const [classData, setClassData] = useState<ClassData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");

    const { sessionToken } = useAuth();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

    // Function to fetch data from your API
    const fetchData = async (locationName: string, URL : string) => {
        try {
            const url = `${URL}/db/current_class?location_name=${encodeURIComponent(locationName)}`;
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${sessionToken}`,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                throw new Error("Error fetching class data");
            }
            const data: ClassData[] = await response.json();
            // Assume the API returns an array; use the first element as the current class.
            if (data && data.length > 0) {
                setClassData(data[0]);
            } else {
                setClassData(null);
            }
        } catch (err: any) {
            console.error("Fetch error:", err);
            setError("Failed to fetch class data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(locationName,API_BASE_URL);
    }, [locationName, API_BASE_URL]);

    if (loading) {
        return (
            <MDBox p={2}>
                <MDTypography variant="h6">Loading Current Class...</MDTypography>
            </MDBox>
        );
    }

    if (error) {
        return (
            <MDBox p={2}>
                <MDTypography variant="h6" color="error">
                    {error}
                </MDTypography>
            </MDBox>
        );
    }

    if (!classData) {
        return (
            <MDBox p={2}>
                <MDTypography variant="h6">Current Class</MDTypography>
                <MDTypography variant="body2">No Class In Session</MDTypography>
            </MDBox>
        );
    }

    return (
        <MDBox p={2}>
            <MDTypography variant="h6">Current Class</MDTypography>
            <MDTypography variant="subtitle1">
                {new Date(classData.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}{" "}
                -{" "}
                {new Date(classData.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </MDTypography>
            <MDTypography variant="body2" color="text">
                {classData.class_name}
                <br />
                {classData.instructor}
            </MDTypography>
        </MDBox>
    );
};

export default CurrentClass;
